<section class="content-header">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-6">
        <h1>AI Batch İşleri</h1>
      </div>
      <div class="col-sm-6">
        <div class="float-right">
          <button class="btn btn-outline-secondary" (click)="loadJobs()">
            <i class="fas fa-sync"></i> Yenile
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="content">
  <div class="container-fluid">
    <div class="card">
      <div class="card-body">
        <div *ngIf="loading" class="text-center">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Yükleniyor...</span>
          </div>
        </div>

        <div *ngIf="!loading && jobs.length === 0" class="alert alert-info">
          Henüz başlatılmış bir batch işi bulunmamaktadır. Bir seviye sayfasından "AI Soru Üret (Batch)" veya "AI Kelime Anlamı Üret (Batch)" butonlarıyla başlatabilirsiniz.
        </div>

        <div *ngIf="!loading && jobs.length > 0" class="table-responsive">
          <table class="table table-bordered table-hover">
            <thead>
              <tr>
                <th>#</th>
                <th>Seviye</th>
                <th>Sağlayıcı</th>
                <th>Tür</th>
                <th>Kelime Sayısı</th>
                <th>Durum</th>
                <th>Oluşturulma</th>
                <th>Son Kontrol</th>
                <th style="width: 220px">İşlemler</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let job of jobs">
                <td>{{ job.id }}</td>
                <td>{{ job.levelDisplayName }}</td>
                <td>{{ job.provider || 'Gemini' }}</td>
                <td>{{ job.kind === 'WordMeanings' ? 'Kelime Anlamı' : 'Soru' }}</td>
                <td>{{ job.keywordCount }}</td>
                <td>
                  <span class="badge"
                        [ngClass]="{
                          'badge-secondary': job.status === 'Pending',
                          'badge-info': job.status === 'Running',
                          'badge-success': job.status === 'Succeeded' || job.status === 'Processed',
                          'badge-danger': job.status === 'Failed',
                          'badge-warning': job.status === 'Unknown'
                        }">{{ job.status }}</span>
                  <div *ngIf="job.errorMessage" class="text-danger small mt-1">{{ job.errorMessage }}</div>
                </td>
                <td>{{ job.createdAt | date:'short' }}</td>
                <td>{{ job.lastCheckedAt ? (job.lastCheckedAt | date:'short') : '-' }}</td>
                <td>
                  <button class="btn btn-sm btn-info mr-1"
                          [disabled]="isBusy(job.id)"
                          (click)="checkStatus(job)"
                          title="Durumu Kontrol Et">
                    <span *ngIf="isBusy(job.id)" class="spinner-border spinner-border-sm"></span>
                    Durumu Kontrol Et
                  </button>
                  <button class="btn btn-sm btn-success"
                          [disabled]="isBusy(job.id) || (job.status !== 'Succeeded')"
                          (click)="fetchResults(job)"
                          title="Sonuçları Getir">
                    Sonuçları Getir
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</section>
